// eslint-disable-next-line import/no-restricted-paths
import { colorToken, colorValue } from './colors';

/**
 * Design system root object
 *
 * Use `colorToken` when styling ReStyle components, that need tokens, eg `ds.colorToken.background.neutral.base`
 * Use `colorValue` when styling React components or in StyleSheets that need hex-values, eg `ds.colorValue.background.neutral.base`
 */
const ds = { colorToken, colorValue };

export { ds };
